import { z } from 'zod/v4';

export const weatherAlertsSchema = z.object({
  notificationEnabled: z.boolean().optional().nullable(),
  weatherNotificationInterval: z.number().optional().nullable(),
  weatherAlertsType: z.number().optional().nullable(),
  minRoadIndex: z.number().optional().nullable(),
  minDisruptionIndex: z.number().optional().nullable(),
  minTippingIndex: z.number().optional().nullable(),
  minWindSpeed: z.number().optional().nullable(),
  minWindGust: z.number().optional().nullable(),
  minSpeedReduction: z.number().optional().nullable(),
  minVisibility: z.number().optional().nullable(),
  minTemperature: z.number().optional().nullable(),
  maxTemperature: z.number().optional().nullable(),
});

export type WeatherAlerts = z.infer<typeof weatherAlertsSchema>;
